import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const ShareWindowAuth0 = ({ children }) => {
  const auth0 = useAuth0();

  useEffect(() => {
    window.auth0 = auth0;
  }, [auth0]);

  return children;
};

export default ShareWindowAuth0;
